import { Dialog, Icon } from "@material-ui/core";
import { useCardReader } from "application/contexts/cardReader/CardReaderContext";
import {
  ResolutionType,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";
import { IOrder } from "modules/order/domain/models/IOrder";
import { ICardCashless } from "modules/payment/domain/models/ICashless";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { createDefferedPromise } from "utils/DefferedPromise";
import totemGif from "../../../../assets/images/totem.gif";
import styles from "./Cashless.module.scss";
import { useTranslation } from "i18n/useTranslation";
export interface ICashlessReturn {
  cardData: ICardCashless;
  order: IOrder;
}

export interface ICashlessHandler {
  open(order: IOrder): Promise<ICashlessReturn>;
}

interface ICashlessProps {}

const UseCashless: React.ForwardRefRenderFunction<
  ICashlessHandler,
  ICashlessProps
> = (_, ref) => {
  const deffered = useRef(createDefferedPromise<ICashlessReturn>());
  const { cardData, enableSensor, disableSensor, clearCardData } =
    useCardReader();
  const { resolution } = useScreenStore();
  const { t } = useTranslation();

  const [visible, setVisible] = useState(false);
  const [order, setOrder] = useState<IOrder>({} as IOrder);

  const open = useCallback(
    (_order: IOrder) => {
      clearCardData();
      enableSensor();
      setOrder(_order);
      setVisible(true);
      deffered.current = createDefferedPromise<ICashlessReturn>();
      return deffered.current.promise;
    },
    [clearCardData, enableSensor]
  );

  useImperativeHandle(ref, () => ({ open }));

  useEffect(() => {
    if (cardData) {
      setVisible(false);
      disableSensor();
      deffered.current.resolver({ cardData, order });
    }
  }, [cardData, disableSensor, order]);

  const onCancel = useCallback(() => {
    setVisible(false);
    disableSensor();
    clearCardData();
    deffered.current?.rejecter(
      new Error("Fechado pelo usuário ou tempo esgotado")
    );
  }, [clearCardData, disableSensor]);

  return (
    <Dialog open={visible} id={styles.Cashless} fullScreen fullWidth>
      <div className={styles.cashlessModal}>
        <Icon className={styles.backButton} onClick={onCancel}>
          chevron_left
        </Icon>

        {!cardData && (
          <div className={styles.readCard}>
            <span
              style={{
                fontSize: resolution === ResolutionType.FULL_HD ? 45 : 30,
              }}
            >
              {(t("cashless.read_card_instruction"))}
            </span>
            <img
              src={totemGif}
              alt="Animação"
              style={{
                width: resolution === ResolutionType.FULL_HD ? 1000 : 700,
                height: resolution === ResolutionType.FULL_HD ? 1000 : 700,
              }}
            />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default forwardRef(UseCashless);
